import React, { useEffect, useState } from "react"
import { Row, Col } from "reactstrap"
import { connect } from 'react-redux';
import { Link } from "react-router-dom"
import {
  Sparklines,
  SparklinesBars,
} from "react-sparklines"
import { useLocation, useNavigate } from "react-router-dom";

const Breadcrumb = props => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pageTitle, setpageTitle] = useState(null);
  const [scannedUrl, setScannedUrl] = useState('');

  const itemLength = (props.breadcrumbItems || []).length || 1;

  useEffect(() => {
    const title = location.pathname.replace(/\//g, "").toLowerCase();
    setpageTitle(title);
  }, [location]);

  useEffect(() => {
    if (sessionStorage.getItem('scannedUrl'))
      setScannedUrl(sessionStorage.getItem('scannedUrl'))
  }, [sessionStorage.getItem('scannedUrl')]);

  const scanPages = [
    'scanlist',
    'siteurlsummary',
    'accessibility',
    'websecurity',
    'analytics',
    'siteperformance',
    'searchengine',
    'mailserver',
    'uswds',
    'technology',
    'vulnerability'
  ]

  return (
    <Row className="items-center md:mb-0">
      <Col md={6}>
        <div className="page-title-box">

          <h4>{props.title}</h4>
          <ol className="breadcrumb m-0">
            {
              (props.breadcrumbItems || []).map((item, key) =>
                (key + 1) === itemLength ?
                  <li key={key} className="breadcrumb-item active">{item.title}</li>
                  : <li key={key} className="breadcrumb-item"><Link to={item.link}>{item.title}</Link></li>
              )
            }
          </ol>
        </div>
      </Col>
      <Col md={6}>
        {scanPages.includes(pageTitle) && scannedUrl && (
          <div
            className="md:self-end"
            style={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
              gap: '10px',
              fontSize: '20px',
              color: '#c75734',
              backgroundColor: '#e6755230',
              width: 'fit-content',
              padding: '0.2em 1em',
              borderRadius: '5px',
              marginBottom: '1.5em'
            }}
          >
            <i style={{ fontSize: '28px' }} className="mdi mdi-link"></i>
            <span>{scannedUrl}</span>
          </div>
        )}

        {/* {pageTitle === "usermanagement" && (
          <button
            type="button"
            className="waves-effect float-end d-flex align-items-center waves-light btn btn-primary"
            style={{ fontSize: "0.9rem" }}
          >
            <i className="mdi mdi-plus fw-bold font-size-17 pe-1"></i>{" "}
            Add User
          </button>
        )
        } */}

        {pageTitle === "useraccess" && (
          <button
            type="button"
            className="waves-effect d-flex align-items-center waves-light btn btn-primary md:ms-auto"
            style={{ fontSize: "0.9rem" }}
            onClick={() => navigate(-1)}
          >
            <i className="mdi mdi-arrow-left fw-bold font-size-17 pe-1"></i>{" "}
            Go Back
          </button>
        )
        }
      </Col>
    </Row>
  )
}

const mapStatetoProps = state => {
  const Layout = state.Layout;
  const BreadcrumbData = state.Breadcrumb
  return { layoutType: Layout.layoutType, title: BreadcrumbData.title, breadcrumbItems: BreadcrumbData.breadcrumbItems };
};

export default connect(mapStatetoProps, {})(Breadcrumb);
